<template>
  <div
    class="c-filter-bar__filter"
    v-click-outside="onClickOutside"
    :class="{ 'is-open': isOpen }"
  >
    <label class="c-filter-bar__label" for="filter_by" @click="openFilter">
      Filter
      <span class="u-hide-tablet">{{ "&nbsp;" }}by</span>
      <div class="c-filter-bar__control" @click="openFilter">
        <form-multiselect
          :show-valid-tick="false"
          :show-drop-icon="true"
          ref="filter"
          ghost
          autocomplete="off"
          placeholder="All"
          v-model="filterQuery"
          :options="filterOptions"
          :multiple="true"
          label="name"
          track-by="name"
          :searchable="true"
          @input="filter"
          :limit="1"
          :long="true"
        ></form-multiselect>
      </div>
    </label>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
  name: "filter-bar-filter",
  props: {
    action: String,
    filterOptions: [Array],
    resource: {
      type: String,
      default: "documents",
    },
    filterUrlParam: {
      type: String,
      default: null,
    },
  },

  // props: ["filterOptions", "resource"],

  data() {
    return {
      filterQuery: [],
      isOpen: false,
    };
  },

  computed: {
    tabFilter() {
      return this.$store.state[this.resource].tabFilter;
    },
  },

  methods: {
    openFilter() {
      this.isOpen = !this.isOpen;
      this.$refs.filter.open();
    },

    filter() {
      const vm = this;
      const queryIds = [];

      this.filterQuery.forEach((queryItem) => {
        queryIds.push(queryItem.id);
      });

      this.$store.commit(`${this.resource}/setFilterCategories`, queryIds);
      this.$store.dispatch(`${this.resource}/${this.action}`, this.tabFilter);
      let queries = JSON.parse(JSON.stringify(this.$route.query));
      queries[this.filterUrlParam] = queryIds.join(",");
      queries.page = 1; // reset to first page
      this.$router.replace({ query: queries });
      this.isOpen = false;
    },

    onClickOutside() {
      this.$refs.filter.close();
    },
  },

  directives: {
    ClickOutside,
  },
  mounted() {
    // if we have defined a url parameter to filter by and it exists in the current route
    if (
      this.filterUrlParam != null &&
      this.$route.query[this.filterUrlParam] &&
      this.$route.query[this.filterUrlParam] != ""
    ) {
      const preselect = this.$route.query[this.filterUrlParam].split(",");
      console.log(
        "🚀 ~ file: FilterBarFilter.vue ~ line 106 ~ mounted ~ preselect",
        preselect
      );
      console.log(
        "🚀 ~ file: FilterBarFilter.vue ~ line 113 ~ mounted ~ this.filterOptions",
        this.filterOptions
      );
      const options = this.filterOptions
        .filter((option) =>
          preselect.includes(
            option.id ? option.id.toString() : option.toString()
          )
        )
        .map((option) => ({
          id: option.id,
          name: option.name ? option.name : option.title,
        }));

      if (options.length > 0) {
        this.filterQuery = options;
      }
    }
  },
};
</script>

<style lang="scss">
/**
 * A lot of the styles have been hacked in here, if possible move to FormMultiselect component
 */
.c-filter-bar__filter {
  position: relative;
  flex: 5;
  max-width: 350px;
  display: block;

  &:after {
    content: "";
    border: 5px solid transparent;
    border-top: 7px solid $colour-nhs-dark-grey;
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -4px;
  }

  @media screen and (min-width: 768px) {
    max-width: 999rem;
    &:after {
      display: none;
    }
    flex: initial;
  }

  .c-filter-bar__control {
    display: none;
    position: unset;

    @media screen and (min-width: 1024px) {
      display: flex;
      position: relative;
      max-width: 999rem;
    }
  }

  &.is-open {
    // @media (min-width: 768px) {
    .c-filter-bar__control {
      display: flex;
      max-width: 350px;
      // }
    }
  }

  .multiselect {
    position: unset;

    &.long {
      // min-width: 0px;
    }

    &--active {
      &:before {
        content: "";
        width: 100vw;
        height: 100vh;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.5);
        position: fixed;
        z-index: 50;
      }
    }

    @media (min-width: 768px) {
      &:before {
        display: none;
      }
    }
  }

  .c-form-field__drop-icon {
    display: none;

    @media (min-width: 768px) {
      display: inline-flex;
    }
  }

  .multiselect__content-wrapper {
    position: fixed;
    bottom: -100vh;
    animation: slideUp 0.2s ease-in-out forwards;
    left: 0;
    z-index: 51;
    @media (min-width: 768px) {
      animation: none;
      position: absolute;
      bottom: auto;
    }
  }

  .multiselect__option {
    border-bottom: 1px solid $colour-nhs-pale-grey;
    padding: 20px;
    @media (min-width: 768px) {
      padding: 10px;
    }
  }

  .multiselect__option--selected {
    color: $colour-nhs-blue;
    position: relative;

    &:after {
      content: "";
      background: url("data:image/svg+xml; utf8, %3Csvg%20width%3D%2216%22%20height%3D%2211%22%20viewBox%3D%220%200%2016%2011%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M15%201.00003L5.375%2010L1%205.90912%22%20stroke%3D%22%23005EB8%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fsvg%3E%0A")
        center center no-repeat;
      background-size: 100%;
      position: absolute;
      right: 10px;
      top: 50%;
      margin-top: -5px;
      width: 14px;
      height: 9px;
    }
  }

  .c-form-multiselect__tag,
  .multiselect__tags {
    display: none;

    @media (min-width: 768px) {
      display: flex;
    }
  }
}

@keyframes slideUp {
  0% {
    bottom: -100vh;
  }
  100% {
    bottom: 0;
  }
}

.c-filter-bar__label {
  display: inline;
}
</style>
